import { render, staticRenderFns } from "./feature-panel.vue?vue&type=template&id=d5560aea"
import script from "./feature-panel.vue?vue&type=script&lang=js"
export * from "./feature-panel.vue?vue&type=script&lang=js"
import style0 from "./feature-panel.vue?vue&type=style&index=0&id=d5560aea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports